import React, { useState } from 'react';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; 


const UpdateLesson = ({formData,setFormData,onClose,handleUpdateSubmit,handleChange}) => {

  
   const handleQuillChangedescription = (value) => {
        setFormData((prev) => ({
            ...prev,
            description: value || "",
        }));
    };

    // দ্বিতীয় Quill-এর জন্য হ্যান্ডলার
    const handleQuillChangeresources = (value) => {
        setFormData((prev) => ({
            ...prev,
            resources: value || "",
        }));
    };
    
  
  return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto p-10">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-800">Update Lesson</h2>
            <button
              onClick={() => {
                setFormData({
                  title: "",
                  videoUrl: "",
                  description: "",
                  resources: ""
                });
                if (onClose) onClose();
              }}
              className="text-gray-500 hover:text-gray-700 text-2xl"
            >
              &times;
            </button>

          </div>
          {/* Form for updating lesson */}

          <form onSubmit={handleUpdateSubmit} className="mt-4">
            <div className="mb-4">
              <label className="block text-gray-700">Sort Order Id</label>
              <input
                type="text"
                name="sort_order"
                value={formData.sort_order}
                onChange={handleChange}
                className="border w-full p-2"
                placeholder="Enter Sort Order"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Lesson Title</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Lesson Title"
                className="border border-gray-300 p-2 rounded mb-2 w-full"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Video URL</label>
               <input
                  type="text"
                  name="videoUrl"
                  value={formData.videoUrl}
                  onChange={handleChange}
                  placeholder="Video URL"
                  className="border border-gray-300 p-2 rounded mb-2 w-full"
                />
            </div>
            
           
            <div className="mb-4">
                <label className="block mb-2">Description</label>
                <ReactQuill
                    value={formData.description || ""}
                    onChange={handleQuillChangedescription}
                    className="border w-full p-2"
                    modules={{
                        toolbar: [
                            [{ 'header': [1, 2, false] }],
                            ['bold', 'italic', 'underline', 'strike'],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            ['link', 'image'],
                            ['clean']
                        ]
                    }}
                    theme="snow"
                />
            </div>
            
            <div className="mb-4">
                <label className="block mb-2">Resources</label>
                <ReactQuill
                    value={formData.resources || ""}
                    onChange={handleQuillChangeresources}
                    className="border w-full p-2"
                    modules={{
                        toolbar: [
                            [{ 'header': [1, 2, false] }],
                            ['bold', 'italic', 'underline', 'strike'],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            ['link', 'image'],
                            ['clean']
                        ]
                    }}
                    theme="snow"
                />
            </div>
            <button className="bg-blue-600 text-white px-3 py-2 rounded hover:bg-blue-700">
              Update Lesson
            </button>
          </form>
        </div>
      </div>
  );
};

export default UpdateLesson;